<ng-container *ngIf="get as componentGet">
    <tt-input-number
        ttLabel="special_length_helpcalc"
        [(ttModel)]="componentGet.special_length"
        (ttModelChange)="calculate('special_length')"
        ttTextAlign="right"
        ttFormatNumber
        ttDecimals="4"
    ></tt-input-number>
    <tt-input-number
        ttLabel="special_width_helpcalc"
        [(ttModel)]="componentGet.special_width"
        (ttModelChange)="calculate('special_width')"
        ttTextAlign="right"
        ttFormatNumber
        ttDecimals="4"
    ></tt-input-number>
    <tt-input-number
        ttLabel="special_quantity_helpcalc"
        [(ttModel)]="componentGet.special_quantity"
        (ttModelChange)="calculate('special_quantity')"
        ttTextAlign="right"
        ttFormatNumber
        ttDecimals="4"
    ></tt-input-number>
    <tt-input ttLabel="special_quantity_formula_helpcalc" [(ttModel)]="componentGet.special_quantity_formula" (ttModelChange)="calculate('special_quantity_formula')"></tt-input>
    <tt-select
        ttLabel="input_unit_help_helpcalc"
        [(ttModel)]="componentGet.input_unit_no"
        (ttModelChange)="calculate('input_unit_no')"
        [ttData]="productUnits"
        ttDataId="unit_no"
        ttDataName="shortname"
    ></tt-select>
    <tt-input-number
        ttLabel="input_quantity_helpcalc"
        [(ttModel)]="componentGet.input_quantity"
        (ttModelChange)="calculate('input_quantity')"
        ttFormatNumber
        ttTextAlign="right"
        ttDecimals="4"
    ></tt-input-number>
    <tt-input-number
        ttLabel="input_calc_quantity_helpcalc"
        [(ttModel)]="componentGet.input_calc_quantity"
        (ttModelChange)="calculate('input_calc_quantity')"
        ttTextAlign="right"
        ttFormatNumber
        ttDecimals="2"
    ></tt-input-number>
</ng-container>
